import Player from '@vimeo/player';
import loadYouTubeAPI from '../utilities/youtube-api.js';

const initVideopopup = (elements) => {
    const playVideo = (event, el, player, type, body) => {
        event.preventDefault();
        body.classList.add('stop-scrolling', 'video-playing');
        el.classList.add('playing');

        if (type === 'vimeo') {
            player.play();
        } else {
            player.playVideo();
        }
    };

    const stopVideo = (event, el, player, type, body) => {
        event.preventDefault();
        body.classList.remove('stop-scrolling', 'video-playing');
        el.classList.remove('playing');

        if (type === 'vimeo') {
            player.pause();
        } else {
            player.pauseVideo();
        }
    };

    const initPlayer = async (btn, type) => {
        const body = document.querySelector('.js-body');
        const container = btn.closest('.grid-container');
        const popupEl = container.querySelector('.js-video-popup');
        const video = container.querySelector('.js-video-popup-iframe');
        const closeBtn = container.querySelector('.js-video-popup-close');

        let player;

        if (type === 'youtube') {
            const YT = await loadYouTubeAPI();
            player = new YT.Player(video);
        } else {
            player = new Player(video);
        }

        btn.addEventListener('click', (event) => {
            playVideo(event, popupEl, player, type, body);
        });

        closeBtn.addEventListener('click', (event) => {
            stopVideo(event, popupEl, player, type, body);
        });
    };

    elements.forEach((el) => {
        const embedType = el.dataset.videoEmbed;
        initPlayer(el, embedType);
    });
};

export default initVideopopup;
